module.exports = __webpack_public_path__ + "static/media/close.dac109c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Frontend/assets/iconos/close.svg
// module id = 8
// module chunks = 0